import React from "react";
import { Link } from "react-router-dom";

export function Logo({ className = "", to = "/", size = "h-9" }) {
  return (
    <Link to={to} className={`flex items-center ${className}`} data-testid="invixa-logo">
      <img src="/assets/invixa-logo.png" alt="INVIXA TRADERS" className={`${size} w-auto object-contain`} />
    </Link>
  );
}
